import { LeafBMark } from './TheBackyardLogo';

/**
 * The Backyard garden loading splash — a deep forest-green backdrop with warm string-light
 * glows, the leaf-B mark, and a subtle progress shimmer. Shown while a screen's data loads.
 */
export function GardenLoader({ label = 'Setting the table…', full = true }: { label?: string; full?: boolean }) {
  return (
    <div
      className={full ? 'fixed inset-0 z-[60] flex flex-col items-center justify-center' : 'flex min-h-[60vh] flex-col items-center justify-center'}
      style={{
        background:
          'radial-gradient(120% 90% at 50% 30%, #1c3324 0%, #152618 55%, #0d1a11 100%)',
      }}
    >
      {/* string lights */}
      <div className='pointer-events-none absolute inset-x-0 top-0 flex justify-between px-6 pt-5 opacity-80'>
        {Array.from({ length: 9 }).map((_, i) => (
          <span
            key={i}
            className='h-1.5 w-1.5 rounded-full'
            style={{ background: '#E8C36B', boxShadow: '0 0 10px 3px rgba(232,195,107,0.35)', marginTop: (i % 2) * 10 }}
          />
        ))}
      </div>

      <div className='relative flex flex-col items-center gap-4'>
        <span className='flex h-20 w-20 items-center justify-center rounded-2xl' style={{ background: 'rgba(201,154,62,0.14)', color: '#C99A3E' }}>
          <LeafBMark size={44} className='animate-pulse' />
        </span>
        <div className='flex flex-col items-center gap-1'>
          <div className='font-display text-lg font-extrabold tracking-tight' style={{ color: '#F3EAD7' }}>
            The Backyard
          </div>
          <div className='text-[11px] font-semibold uppercase tracking-[0.3em]' style={{ color: '#C99A3E' }}>
            Jaipur
          </div>
        </div>
        {/* progress shimmer */}
        <div className='mt-1 h-1 w-40 overflow-hidden rounded-full' style={{ background: 'rgba(255,255,255,0.08)' }}>
          <div className='h-full w-1/2 rounded-full bg-[#C99A3E]' style={{ animation: 'byloader 1.1s ease-in-out infinite' }} />
        </div>
        <div className='text-[12.5px]' style={{ color: 'rgba(243,234,215,0.7)' }}>{label}</div>
      </div>

      <style>{`@keyframes byloader{0%{transform:translateX(-120%)}100%{transform:translateX(280%)}}`}</style>
    </div>
  );
}
